import React, { useEffect, useState } from "react";
import "./OffersPage.css";
import { useSelector, useDispatch } from "react-redux";
import { setOffers } from "../../../../../store/app/appReducer";
import callApi from "../../../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import OfferCard from "./OfferCard";
import { TRACK_ID } from "../../../../../utility/enum";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import BPCreditCard from "../../../../BharatpeCreditCard";
const OfferPage = ({ formData, setShowOfferHeaderLogo }) => {
  const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  const dispatch = useDispatch();
  const [isFinished, setIsFinished] = useState(false);
  const [leadId, setLeadId] = useState();
  const [expandedOfferId, setExpandedOfferId] = useState(null);
  const [activeLenders, setActiveLenders] = useState([]);
  const [params] = useSearchParams();
  const [isTncChecked, setIsTncChecked] = useState(true);
  const mobile = formData?.mobile || "";
  const navigate = useNavigate();
  const [source, setSource] = useState("");
  const [leadData, setLeadDate] = useState({});
  const token = user?.token;
  const [failedList, setFailedList] = useState([]);

  const [ipAddress, setIpAddress] = useState("");

  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        // ipAddress = data?.ip;
        setIpAddress(data?.ip);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  useEffect(() => {
    fetchIp();
  }, []);

  useEffect(() => {
    fetchActiveLenders();
  }, []);

  useEffect(() => {
    if (formData.stepDone === 3 && !leadId) {
      submitLead();
    }
  }, [formData]);

  useEffect(() => {
    if (offers.length > 0 && !expandedOfferId) {
      setExpandedOfferId(offers[0]._id);
    }
  }, [offers]);

  useEffect(() => {
    if (offers.length > 0) {
      setShowOfferHeaderLogo(false);
    }
  }, [offers]);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];

        const hardcodedLender = {
          _id: "662752eb65fdba1a48d6e482",
          lender_name: "L&T",
        };

        const mergedLenders = [...apiLenders];

        setActiveLenders(mergedLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const submitLead = async () => {
    setUserClickData({
      event_name: "submit-lead-offer-check-v2",
      user_id: leadId || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });
    try {
      const leadResponse = await callApi(
        "v1/lead/lead-from-phone",
        "post",
        {
          phone: mobile,
          website_kyc_consent: isTncChecked,
        },
        "core",
        token
      );

      if (leadResponse["status"] === "Success" && leadResponse.data.lead) {
        const leadData = leadResponse.data.lead;
        setLeadDate(leadData);
        const ltResponse = await callApi(
          "v1/lender_api_call/list",
          "post",
          {
            filters: {
              lead_id: leadData._id,
              lender_name: {
                $in: ["UnityBank", "Incred", "Tata Capital", "L&T"],
              },
            },
            pageSize: 10,
            pageNum: 1,
          },
          "loan_service"
        );

        const lendersData = await callApi(
          "v1/lender/list",
          "post",
          {
            filters: {
              name: { $in: ["UnityBank", "Incred", "Tata Capital", "L&T"] },
            },
            pageSize: 10,
            pageNum: 1,
          },
          "loan_service",
          token
        );

        const coreLeadCheck = await callApi(
          "v1/lead/list",
          "post",
          {
            filters: {
              _id: leadData._id,
            },
          },
          "core"
        );

        const foundLead = coreLeadCheck?.data?.leadList?.[0];
        console.log(
          "foundLead",
          foundLead?._id,
          foundLead?.is_landt_finbud_success
        );
        // if (ltResponse?.data?.lender_api_callCount > 0) {
        //   if (foundLead?.is_landt_finbud_success === true) {
        //     console.log(
        //       "Calling data-send-with-offers-to-ican_for_lt_finbud_sucess",
        //       {
        //         lead_id: leadData._id,
        //       }
        //     );
        //     await callApi(
        //       "v1/ican_api/data-send-with-offers-to-ican_for_lt_finbud_sucess",
        //       "post",
        //       {
        //         lead_id: leadData._id,
        //       },
        //       "core"
        //     );
        //   }
        // } else {
        // if (foundLead?.data?.lender_api_callCount < 2) {
        //   console.log("Calling bulk-lead-push-by-leadId", {
        //     leads: [{ lead_id: leadData._id }],
        //     lender_name: "UnityBank",
        //     lender_id: "67762d497ae263a3ec86347e",
        //   });

        if (ltResponse.data?.lender_api_callCount < 2) {
          const isUnityPresent = ltResponse.data.lender_api_callList.some(
            (entry) => entry.lender_name.toLowerCase() === "unitybank"
          );

          if (!isUnityPresent) {
            console.log("Calling bulk-lead-push-by-leadId for UnityBank", {
              leads: [{ lead_id: leadData._id }],
              lender_name: "UnityBank",
              lender_id: "67762d497ae263a3ec86347e",
            });
            await callApi(
              "v1/lead/bulk-lead-push-by-leadId",
              "post",
              {
                leads: [{ lead_id: leadData._id }],
                lender_name: "UnityBank",
                lender_id: "67762d497ae263a3ec86347e",
              },
              "core",
              token
            );
          }

          const isIncredPresent = ltResponse.data.lender_api_callList.some(
            (entry) => entry.lender_name.toLowerCase() === "incred"
          );

          const incredLender = lendersData.data.lenderList.filter(
            (item) => item.name === "Incred"
          );

          if (!isIncredPresent && incredLender[0].otp_page_api_push === true) {
            console.log("Calling bulk-lead-push-by-leadId for Incred", {
              leads: [{ lead_id: leadData._id }],
              lender_name: "Incred",
              lender_id: "68401febe871a7a9504dc2e3",
            });
            await callApi(
              "v1/lead/bulk-lead-push-by-leadId",
              "post",
              {
                leads: [{ lead_id: leadData._id }],
                lender_name: "Incred",
                lender_id: "68401febe871a7a9504dc2e3",
              },
              "core",
              token
            );
          }

          const isTataPresent = ltResponse.data.lender_api_callList.some(
            (entry) => entry.lender_name.toLowerCase() === "tata capital"
          );
           const TataLender = lendersData.data.lenderList.filter(
              (item) => item.name.toLowerCase() === "tata capital"
            );

            if (!isTataPresent && TataLender[0].otp_page_api_push === true) {
            console.log("Calling bulk-lead-push-by-leadId for tata capital", {
              leads: [{ lead_id: leadData._id }],
              lender_name: "Tata Capital",
              lender_id: "66b5b42d123877ad47aa4745",
            });
            await callApi(
              "v1/lead/bulk-lead-push-by-leadId",
              "post",
              {
                leads: [{ lead_id: leadData._id }],
                lender_name: "Tata Capital",
                lender_id: "66b5b42d123877ad47aa4745",
              },
              "core",
              token
            );
          }
        }
        // await callApi(
        //   "v1/lead/bulk-lead-push-by-leadId",
        //   "post",
        //   {
        //     leads: [{ lead_id: leadData._id }],
        //     lender_name: "UnityBank",
        //     lender_id: "67762d497ae263a3ec86347e",
        //   },
        //   "core",
        //   token
        // );
        // await callApi(
        //   "v1/lead/bulk-lead-push-by-leadId",
        //   "post",
        //   {
        //     leads: [{ lead_id: leadData._id }],
        //     lender_name: "Incred",
        //     lender_id: "68401febe871a7a9504dc2e3",
        //   },
        //   "core",
        //   token
        // );

        // }

        const isLandTPresent = ltResponse.data.lender_api_callList.some(
          (entry) => entry.lender_name === "L&T"
        );
        const LandTLender = lendersData.data.lenderList.filter(
          (item) => item.name === "L&T"
        );

        if (!isLandTPresent && LandTLender[0].otp_page_api_push === true) {
          console.log("Calling bulk-lead-push-by-leadId for L&T", {
            leads: [{ lead_id: leadData._id }],
            lender_name: "L&T",
            lender_id: "662752eb65fdba1a48d6e482",
          });
          await callApi(
            "v1/lead/bulk-lead-push-by-leadId",
            "post",
            {
              leads: [{ lead_id: leadData._id }],
              lender_name: "L&T",
              lender_id: "662752eb65fdba1a48d6e482",
            },
            "core",
            token
          );
        }

        await callApi(
          "v1/ican_api/ican_journey_tag_update",
          "post",
          {
            priority: "P1",
            lead_id: leadData._id,
          },
          "core"
        );
        await fetchOffers(leadData._id);
        // navigate(`/offers?lid=${leadData._id}&source=${source}`);
      } else {
        navigate(`/personal-loan?source=${source}`);
      }
    } catch (error) {
      console.log("Error fetching lead or calling APIs:", error);
      setIsFinished(true);
      navigate(`/personal-loan?source=${source}`);
    }
  };
  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    try {
      // 1️⃣ Fetch offers + active lenders in parallel
      const [offerRes, lenderRes] = await Promise.all([
        callApi(
          `v1/loan_offer/lead_id/${leadId}`,
          "get",
          {},
          "core",
          user.token
        ),
        callApi(`v1/lender/active-lenders`, "get", {}, "loan", user.token),
      ]);

      if (
        offerRes.status === "Success" &&
        offerRes.data?.offers?.length > 0 &&
        lenderRes.status === "Success"
      ) {
        const offers = offerRes.data.offers;
        const apiLenders = lenderRes.data.lenderList ?? [];

        // ✅ 2️⃣ Fetch NEW Successlist data
        const lenderListRes = await callApi(
          `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
          "post",
          {},
          "loan",
          user.token
        );

        if (Array.isArray(lenderListRes.data?.FailList)) {
          setFailedList(lenderListRes.data?.FailList);
        }
        // ✅ 3️⃣ Extract Successlist lenders
        const successLenders =
          lenderListRes.status === "Success" &&
          Array.isArray(lenderListRes.data?.Successlist)
            ? lenderListRes.data.Successlist
            : [];

        // ✅ 4️⃣ Merge all lender data:
        // active lenders + hardcoded lenders + Successlist lenders
        const hardcodedLenders = [
          { lender_id: "67762d497ae263a3ec86347e", lender_name: "UnityBank" },
          { lender_id: "68401febe871a7a9504dc2e3", lender_name: "Incred" },
        ];

        const mergedLenders = [
          ...apiLenders.map((l) => ({ ...l, lender_id: l._id })), // normalize _id → lender_id
          ...hardcodedLenders,
          ...successLenders,
        ];

        // ✅ 5️⃣ Build lender map (keyed by lender_id)
        const lenderMap = Object.fromEntries(
          mergedLenders.map((lender) => [lender.lender_id, lender])
        );

        // ✅ 6️⃣ Enrich each offer with Successlist financial fields
        const enrichedOffers = offers.map((offer) => {
          const lender = lenderMap[offer.lender_id] || {};

          return {
            ...offer,
            apr: lender.apr ?? "",
            kfs_doc: lender.kfs_doc ?? "",
            credit_limit: lender.web_offer ?? "",
            penal_charges: lender.penal_charges ?? "",
            processing_fee: lender.processing_fee ?? "",
            interest_rate: lender.web_interest ?? null, // ✅ "interest"
            lender_name: lender.lender_name ?? offer.lender_name,
          };
        });

        // ✅ 7️⃣ Sort offers by priority
        const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

        // ✅ 8️⃣ Filter only lenders that exist in mergedLenders
        const filteredOffers = sortedOffers.filter((offer) =>
          mergedLenders.some((lender) => lender.lender_id === offer.lender_id)
        );

        // ✅ 9️⃣ Dispatch final enriched offers
        dispatch(setOffers(filteredOffers));
        setIsFinished(true);
        return true;
      } else {
        setIsFinished(true);
        return false;
      }
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return false;
    }
  };

  return (
    <div id="offer-page-v5">
      {offers.length > 0 ? (
        <>
          <div className="final-offers-container-v5">
            <>
              <video
                className="background-video1"
                src="/assets/img/BG video.mp4"
                autoPlay
                loop
                muted
              />
              <img
                src="/assets/img/Offers BG.svg"
                alt="Square Check Background"
                className="background-overlay-img-offer"
              />
            </>
            <div className="offer-bg-layer-v5">
              <h2 className="congrats-text">Congratulations!</h2>
              <h3 className="sub-text">You’re Pre-Qualified for</h3>
              <h3 className="sub-text">a Personal Loan!</h3>
            </div>
          </div>

          <div className="offer-cards-container">
            {offers.map((offer) => (
              <OfferCard
                key={offer._id}
                offer={offer}
                isExpanded={expandedOfferId === offer._id}
                onExpand={() => setExpandedOfferId(offer._id)}
              />
            ))}

            <div
              className="p-4 rounded-xl bg-white-900/80  backdrop-blur-md shadow-lg mx-2"
              style={{ backgroundColor: "white" }}
            >
              {/* Note Header */}
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-semibold uppercase tracking-wide text-red-500">
                  Note
                </span>
              </div>

              {/* Note Text */}
              <p className="text-sm text-black-300 mb-4 leading-relaxed">
                {failedList?.length > 0 && (
                  <p className="text-sm text-black-300 mb-2">
                    There are no matching offers for your request from:{" "}
                    {failedList.join(", ")}
                  </p>
                )}
              </p>
            </div>

            {/* <BPCreditCard
              Lead_id={leadData?._id}
              name={leadData.contact_name}
              contact_phone={leadData?.contact_phone}
            /> */}
            <p className="disclaimer-offer-text-v5">
              Choose from these incredible offers that best suit your needs
            </p>
            <p className="disclaimer-text">
              *These pre-approved offers are subject to change at discretion of
              Bank / NBFC after receiving all your documents and details. Final
              offer will be based on risk policy of Bank / NBFC. We do not
              guarantee that final offer will be same as Pre-approved offer.
            </p>
          </div>
        </>
      ) : isFinished ? (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              There is no offer for you currently.
            </h2>
          </div>
        )
      ) : (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              Please wait while we are searching best offers for you
            </h2>
          </div>
        )
      )}
    </div>
  );
};

export default OfferPage;
